import { render } from "./FooterIconNav.vue?vue&type=template&id=7422e67e&scoped=true"
import script from "./FooterIconNav.vue?vue&type=script&lang=js"
export * from "./FooterIconNav.vue?vue&type=script&lang=js"

import "./FooterIconNav.vue?vue&type=style&index=0&id=7422e67e&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7422e67e"]])

export default __exports__